import { Box, Flex, Heading } from "rebass/styled-components"
import { theme } from "../../theme"
import { ContentWrapper } from "../ContentWrapper"
import { FancyImage } from "../common/FancyImage"
import { StyledText } from "../common/StyledText"
import { data } from "./data"
import * as React from "react"
import { MapTicks } from "./MapTicks"
import styled from "styled-components"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { HeroImage } from "./HeroImage"

export const Hero = () => {
  return (
    <Flex bg={theme.colors.bgDark} mb={[4, 2, 0]}>
      <ContentWrapper style={{ position: "relative" }} maxWidth={1152}>
        <Flex
          style={{
            position: "absolute",
            left: 0,
            overflow: "hidden",
            maxWidth: "calc(100vw - 48px)",
          }}
          mt={[5]}
        >
          <MapTicks />
        </Flex>
        <Flex flexWrap="wrap" style={{ maxWidth: "calc(100vw - 48px)" }}>
          <Flex
            justifyContent="space-between"
            alignItems="center"
            width={[1, 1, 3 / 5]}
            pt={[4, 4, "120px"]}
            pb={"60px"}
          >
            <Box pl={[0, 0, 0, 5]} style={{ zIndex: 1 }}>
              <Heading
                fontSize={["48px", "48px", "48px", "64px"]}
                fontWeight={500}
                maxWidth={["80%", "400px"]}
                mb={3}
                color={theme.colors.headingBgDark}
                fontFamily={"Arnhem"}
              >
                <StyledText
                  text={data.hero.heading}
                  styledFragment={data.hero.headingStyled}
                />
              </Heading>

              <TableOfContents>
                {data.hero.anchors.map(anchor => (
                  <AnchorLink
                    to={`/geography-ticks-and-you#${anchor.id}`}
                    key={anchor.id}
                  >
                    <Pill>{anchor.title}</Pill>
                  </AnchorLink>
                ))}
              </TableOfContents>
            </Box>
          </Flex>

          <Box
            width={[1, 1, 2 / 5]}
            style={{ position: "relative", maxWidth: "calc(100vw - 48px)" }}
            maxWidth={["calc(100vw - 48px)", "calc(100vw - 48px)", "100%"]}
          >
            <ImageWrapper>
              <FancyImage
                imageElement={<HeroImage />}
                leafColor={"#DD5461"}
                circleColor={"#DDCF54"}
              />
            </ImageWrapper>
          </Box>
        </Flex>
      </ContentWrapper>
    </Flex>
  )
}

const ImageWrapper = styled(Flex)`
  > div {
    margin-left: 0;
    top: -35px;
    margin: 0px;
    position: absolute;
    max-width: 100%;
    margin-bottom: -50px;

    .leaf {
      position: absolute;
      bottom: 0px;
      left: -30px;
    }

    @media screen and (min-width: ${theme.breakpoints[1]}) {
      min-height: 484px;
      top: 80px;
      .leaf {
        bottom: 80px;
      }
      .circle {
        bottom: 50px;
        left: 190px;
      }
    }

    @media screen and (min-width: ${theme.breakpoints[2]}) {
      top: 80px;
      bottom: 0px;
      .leaf {
        left: unset;
        right: 200px;
      }
    }

    @media screen and (min-width: ${theme.breakpoints[3]}) {
      .leaf {
        left: unset;
        right: 230px;
        width: 278px;
        height: 241px;
      }
      .circle {
        bottom: 20px;
        left: 190px;
      }
    }
  }
`

const TableOfContents = styled(Flex)`
  flex-wrap: wrap;
  a {
    text-decoration: none;
  }
`

const Pill = styled.div`
  font-family: Gentona-Medium;
  font-size: 16px;
  line-height: 24px;
  color: #f8fbf6;
  padding: 5px 18px;
  background: #1b4942;
  border-radius: 18px;
  margin-bottom: 10px;
  margin-right: 4px;
  cursor: pointer;

  &:hover {
    background: #376c64;
  }
`
